<ng-container>
  <div class="mb-2 ml-1 flex items-center pl-2">
    <p-checkbox
      inputId="allEventsSelected"
      [ngModel]="checkedAll"
      [binary]="true"
      (onChange)="changeSelectAll($event)" />
    <label for="allEventsSelected" class="ml-2">{{ 'layout.widget.type.selectall' | translate }}</label>
  </div>

  <div class="p-panelmenu">
    @for (item of menuItems; track item['key']) {
      @let _children = item.items;

      <div class="p-panelmenu-panel overflow-hidden">
        <div
          #header
          class="p-panelmenu-header"
          [attr.aria-expanded]="item.expanded"
          [attr.aria-label]="item.title"
          (click)="toggleItem($event, item)">
          <div class="p-panelmenu-header-content">
            <ng-container [ngTemplateOutlet]="itemTpl" [ngTemplateOutletContext]="{ item }"></ng-container>
          </div>
        </div>
        @if (_children) {
          <div
            class="p-panelmenu-content-container"
            [attr.aria-labelledby]="header"
            [ngClass]="{
              'p-panelmenu-expanded': item.expanded,
              'hidden h-0': !item.expanded
            }">
            <div class="p-panelmenu-content">
              <ng-container
                [ngTemplateOutlet]="submenuTpl"
                [ngTemplateOutletContext]="{ $implicit: item, level: 1 }"></ng-container>
            </div>
          </div>
        }
      </div>
    }
  </div>
</ng-container>

<ng-template #submenuTpl let-item let-level="level">
  <ul class="p-panelmenu-submenu" [attr.aria-hidden]="!item.expanded">
    @for (child of item.items; track child['key']) {
      <li class="p-panelmenu-item" [attr.aria-level]="level" [attr.aria-expanded]="child.expanded">
        <div class="p-panelmenu-item-content">
          <ng-container [ngTemplateOutlet]="itemTpl" [ngTemplateOutletContext]="{ item: child }"></ng-container>
        </div>
        @if (child.items) {
          <div
            class="p-toggleable-content"
            [ngClass]="{
              'hidden h-0': !child.expanded
            }">
            <ng-container
              [ngTemplateOutlet]="submenuTpl"
              [ngTemplateOutletContext]="{ $implicit: child, level: level + 1 }"></ng-container>
          </div>
        }
      </li>
    }
  </ul>
</ng-template>
